import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetCustomer } from "./useGetCustomer"
import { CustomerEntity } from "../../Objects/Customer/CustomerEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { AuthState } from "../../context/usePublicViewContext"
import { JsonResponse } from "../../Objects/Generics/JsonResponse"
import { ERequestType } from "../../Enum/ERequestType"

export const useSaveCustomer = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetCostumer } = useGetCustomer()

  const handleSavesCostumer = async (costumerChange: CustomerEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = null

      if (costumerChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.CUSTOMER.PUT}/${costumerChange.id}`, costumerChange.toJSON())
      } else {
        response = await PostFormRequest(API_ROUTES.CUSTOMER.CREATE, costumerChange.toJSON())
      }

      if (response.success) {
        await handleGetCostumer(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleSavePublicCostumer = async (rote: string, costumerChange: CustomerEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response: JsonResponse<CustomerEntity> = null

      response = await PutFormRequest<CustomerEntity>(
        `${rote}/${costumerChange.id}`,
        costumerChange.toJSON(),
        ERequestType.Customer,
      )

      if (response.success) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const HandleCreateCustomer = async (
    rote: string,
    costumerChange: CustomerEntity,
    onSuccess: (authState: AuthState) => void,
  ) => {
    enableLoad()

    try {
      const response = await PostFormRequest<AuthState>(rote, costumerChange.toJSON(), ERequestType.Customer)

      if (response.success) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesCostumer,
    HandleCreateCustomer,
    handleSavePublicCostumer,
  }
}
